import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseHttpService} from '@shared/infrastructure/services/http/base-http.service';
import {environment} from '@env/environment';
import {RefundCompletedDTO, RefundRequestDTO} from '@features/payment/domain/model/refund.model';

@Injectable({providedIn: 'root'})
export class InvoicesGateway extends BaseHttpService {
  protected readonly baseUrl = environment.apiURL;

  refund(refundRequest: RefundRequestDTO): Observable<RefundCompletedDTO> {
    return this.post<RefundCompletedDTO>('/api/v2/invoices/refund', refundRequest);
  }
}

